(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/notifications/notifications.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/notifications/notifications.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState;
const Form = svs.ui.reactForm.Form;
const _svs$myProfile$react$ = svs.myProfile.react.shared.components,
  CheckboxItem = _svs$myProfile$react$.CheckboxItem,
  TopHeader = _svs$myProfile$react$.TopHeader;
const _svs$myProfile$react$2 = svs.myProfile.react.shared.tracking,
  trackListChanges = _svs$myProfile$react$2.trackListChanges,
  trackNotification = _svs$myProfile$react$2.trackNotification;
const _svs$myProfile$react$3 = svs.myProfile.react.shared.dialogs,
  showCustomersOldLinkError = _svs$myProfile$react$3.showCustomersOldLinkError,
  showSettingsTechnicalError = _svs$myProfile$react$3.showSettingsTechnicalError;
const _svs$myProfile$react$4 = svs.myProfile.react.shared.helpers,
  clearAllUrlParam = _svs$myProfile$react$4.clearAllUrlParam,
  makeSetting = _svs$myProfile$react$4.makeSetting;
const syndicateMailId = svs.myProfile.constants.syndicateMailId;
const useCustomerSettings = svs.myProfile.react.shared.hooks.useCustomerSettings;
const putCustomersSettingsAsync = svs.myProfile.react.shared.customerSettingsService.putCustomersSettingsAsync;
const setPlayerSettingsData = svs.myProfile.react.store.pd.actions.setPlayerSettingsData;
const _svs$myProfile$consta = svs.myProfile.constants,
  backendName = _svs$myProfile$consta.backendName,
  titles = _svs$myProfile$consta.titles,
  icons = _svs$myProfile$consta.icons;
const _svs$myProfile$react$5 = svs.myProfile.react.pages.notifications,
  notificationsSyndicateService = _svs$myProfile$react$5.notificationsSyndicateService,
  NotificationsSkeleton = _svs$myProfile$react$5.NotificationsSkeleton;
const AppNotifications = svs.myProfile.react.pages.notifications.appNotifications.AppNotifications;
const useSyndicate = svs.myProfile.react.pages.notifications.hooks.useSyndicate;
const _svs$myProfile$react$6 = svs.myProfile.react.pages.notifications.components,
  CheckboxSyndicateItem = _svs$myProfile$react$6.CheckboxSyndicateItem,
  CorrectionMail = _svs$myProfile$react$6.CorrectionMail,
  SyndicateInformation = _svs$myProfile$react$6.SyndicateInformation,
  Section = _svs$myProfile$react$6.Section,
  Marketplace = _svs$myProfile$react$6.Marketplace;

const Notifications = () => {
  const dispatch = ReactRedux.useDispatch();
  const cAndI = ReactRedux.useSelector(state => state.playerDetails.cAndI);
  const _ReactRedux$useSelect = ReactRedux.useSelector(state => state.playerDetails),
    playerSettings = _ReactRedux$useSelect.playerSettings;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasApiErrorShowed = _useState2[0],
    sethasApiErrorShowed = _useState2[1];
  const _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    isSyndicateMember = _useState4[0],
    setIsSyndicateMember = _useState4[1];
  const _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    isSyndicateOwner = _useState6[0],
    setIsSyndicateOwner = _useState6[1];
  const _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    playerSyndicateData = _useState8[0],
    setPlayerSyndicateData = _useState8[1];
  const _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    shouldShowApiError = _useState0[0],
    setShouldShowApiError = _useState0[1];
  const _useState1 = useState(svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)),
    _useState10 = _slicedToArray(_useState1, 1),
    isPlayerLoggedIn = _useState10[0];
  useSyndicate(setPlayerSyndicateData, setIsSyndicateOwner, setIsSyndicateMember, setShouldShowApiError);
  useCustomerSettings(setShouldShowApiError);
  useEffect(() => {
    if (shouldShowApiError && !hasApiErrorShowed) {
      sethasApiErrorShowed(true);
      showSettingsTechnicalError();
    }
  }, [shouldShowApiError, hasApiErrorShowed]);
  useEffect(() => {
    const getData = async () => {
      var _svs$my_profile_react;
      svs.myProfile.logger.debug("**** Player isPlayerLoggedIn: ".concat(isPlayerLoggedIn ? 'Yes' : 'No'));
      const unInLoggedData = (_svs$my_profile_react = svs.my_profile_react.data) === null || _svs$my_profile_react === void 0 ? void 0 : _svs$my_profile_react.communication_settings_react;
      svs.myProfile.logger.debug('get svs.myProfile.data?.communication_settings_react:');
      if (unInLoggedData && unInLoggedData.dataError) {
        clearAllUrlParam();
        showCustomersOldLinkError();
      }
      if (unInLoggedData && unInLoggedData.data) {
        dispatch(setPlayerSettingsData(unInLoggedData.settings));
      }
    };
    getData();
  }, [isPlayerLoggedIn]);
  const handleCheckbox = async (id, isOverride, isEnabledOverride) => {
    svs.myProfile.logger.debug("**** main handleOnChange id: ".concat(id));
    let isEnabled = !playerSettings[id];
    if (isOverride) {
      isEnabled = isEnabledOverride;
    }
    const newPlayerSettingsData = _objectSpread(_objectSpread({}, playerSettings), {}, {
      [id]: isEnabled
    });
    try {
      let res;
      if (isPlayerLoggedIn) {
        res = await putCustomersSettingsAsync([makeSetting(id, !playerSettings[id])]);
      } else {
        const c = cAndI.c,
          i = cAndI.i;
        res = await putCustomersSettingsAsync([makeSetting(id, !playerSettings[id])], c, i);
      }
      const _res = res,
        status = _res.status,
        error = _res.error;
      if (error || status !== 'success') {
        svs.myProfile.logger.debug("**** handleOnChange id: ".concat(id, " error or status not success"), error);
        await showSettingsTechnicalError();
      } else {
        trackListChanges(newPlayerSettingsData, playerSettings, 'notifications');
        dispatch(setPlayerSettingsData(newPlayerSettingsData));
      }
    } catch (error) {
      svs.myProfile.logger.debug("**** handleOnChange id: ".concat(id, " error"), error);
      await showSettingsTechnicalError();
    }
  };
  const handleMultiCheckbox = async (ids, isEnabledBeforeChange, trackingName) => {
    svs.myProfile.logger.debug("**** main multicheckbox ids: ".concat(ids));
    const newSettings = ids;
    const newSettingsArr = [];
    Object.keys(ids).forEach(key => {
      newSettingsArr.push(makeSetting(key, ids[key]));
    });
    const newPlayerSettingsData = _objectSpread(_objectSpread({}, playerSettings), newSettings);
    try {
      let res;
      if (isPlayerLoggedIn) {
        res = await putCustomersSettingsAsync(newSettingsArr);
      } else {
        const c = cAndI.c,
          i = cAndI.i;
        res = await putCustomersSettingsAsync(newSettingsArr, c, i);
      }
      const _res2 = res,
        status = _res2.status,
        error = _res2.error;
      if (error || status !== 'success') {
        svs.myProfile.logger.debug("**** multicheckbox ids: ".concat(ids, ". Error or status not success"), error);
        await showSettingsTechnicalError();
      } else {
        trackNotification(trackingName, !isEnabledBeforeChange);
        dispatch(setPlayerSettingsData(newPlayerSettingsData));
      }
    } catch (error) {
      svs.myProfile.logger.debug("**** multicheckbox ids: ".concat(ids, " error"), error);
      await showSettingsTechnicalError();
    }
  };
  const handleSyndicateCbx = async id => {
    svs.myProfile.logger.debug("**** main handleSyndicateCbx id: ".concat(id));
    const notification = playerSyndicateData.find(item => item.mailTypeId === id);
    const checked = notification.transports.find(item => item.transportType === 'mailNotification');
    const mailNotification = notification.transports.findIndex(item => item.transportType === 'mailNotification');
    const transportType = {
      enabled: !checked.enabled,
      transportType: 'mailNotification'
    };
    const transportArray = notification.transports.slice();
    transportArray[mailNotification] = transportType;
    const newNotification = _objectSpread(_objectSpread({}, notification), {}, {
      transports: transportArray
    });
    if (isPlayerLoggedIn) {
      try {
        const _await$notificationsS = await notificationsSyndicateService.putCustomersSyndicateAsync(newNotification),
          status = _await$notificationsS.status,
          error = _await$notificationsS.error;
        if (error || status !== 'success') {
          svs.myProfile.logger.debug('handleSyndicateCbx: error: ', error);
          showSettingsTechnicalError();
        } else {
          svs.myProfile.logger.debug("handleSyndicateCbx: success :)");
          const notificationIndex = playerSyndicateData.findIndex(item => item.mailTypeId === id);
          const newPlayerSyndicateData = playerSyndicateData.slice();
          newPlayerSyndicateData[notificationIndex] = newNotification;
          trackListChanges(newPlayerSyndicateData, playerSyndicateData, 'syndicate');
          setPlayerSyndicateData(newPlayerSyndicateData);
        }
      } catch (error) {
        showSettingsTechnicalError();
        svs.myProfile.logger.debug('handleSyndicateCbx: catch: error: ', error);
      }
    }
  };
  return React.createElement("div", {
    className: "margin-bottom-4"
  }, React.createElement(Form, null, !playerSettings && React.createElement(NotificationsSkeleton, null), playerSettings && React.createElement(CorrectionMail, {
    handleMultiCheckbox: handleMultiCheckbox,
    model: playerSettings
  }, React.createElement("div", null, React.createElement(CheckboxItem, {
    id: backendName.RECURRING_WAGER_REMINDERS,
    model: playerSettings,
    onChange: handleCheckbox,
    title: "P\xE5minnelsemejl n\xE4r dina flerveckorsspel beh\xF6ver f\xF6rl\xE4ngas"
  })), isPlayerLoggedIn && React.createElement(AppNotifications, null)), isPlayerLoggedIn && React.createElement("div", {
    className: "margin-top-2"
  }, React.createElement(TopHeader, {
    icon: icons.PLAYTOGETHER,
    title: titles.PLAYTOGETHER
  }), playerSyndicateData && React.createElement(SyndicateInformation, {
    isSyndicateMember: isSyndicateMember,
    isSyndicateOwner: isSyndicateOwner
  }), playerSyndicateData && isSyndicateMember && React.createElement(Section, {
    title: "Medlem"
  }, React.createElement("div", {
    className: "margin-bottom"
  }, React.createElement(CheckboxSyndicateItem, {
    id: syndicateMailId.BET,
    model: playerSyndicateData,
    onChange: handleSyndicateCbx,
    title: "Lagda spel"
  })), React.createElement("div", {
    className: "margin-bottom"
  }, React.createElement(CheckboxSyndicateItem, {
    id: syndicateMailId.CANCEL_BET,
    model: playerSyndicateData,
    onChange: handleSyndicateCbx,
    title: "Annullerade spel"
  })), React.createElement("div", {
    className: "margin-bottom"
  }, React.createElement(CheckboxSyndicateItem, {
    id: syndicateMailId.WITHDRAWAL,
    model: playerSyndicateData,
    onChange: handleSyndicateCbx,
    title: "Utbetalningar"
  })), React.createElement(CheckboxSyndicateItem, {
    id: syndicateMailId.TERMINATED,
    model: playerSyndicateData,
    onChange: handleSyndicateCbx,
    title: "Avslutat lag"
  })), playerSyndicateData && isSyndicateOwner && React.createElement("div", {
    className: isSyndicateOwner && isSyndicateMember ? 'padding-top' : ''
  }, React.createElement(Section, {
    title: "Lagledare"
  }, React.createElement("div", {
    className: "margin-bottom"
  }, React.createElement(CheckboxSyndicateItem, {
    id: syndicateMailId.DEPOSIT,
    model: playerSyndicateData,
    onChange: handleSyndicateCbx,
    title: "Ins\xE4ttningar"
  })), React.createElement("div", {
    className: "margin-bottom"
  }, React.createElement(CheckboxSyndicateItem, {
    id: syndicateMailId.WITHDRAWAL_BY_MEM,
    model: playerSyndicateData,
    onChange: handleSyndicateCbx,
    title: "Uttag"
  })), React.createElement("div", {
    className: "margin-bottom"
  }, React.createElement(CheckboxSyndicateItem, {
    id: syndicateMailId.ACCEPT_INVITATION,
    model: playerSyndicateData,
    onChange: handleSyndicateCbx,
    title: "Inbjuden tackar ja"
  })), React.createElement("div", {
    className: "margin-bottom"
  }, React.createElement(CheckboxSyndicateItem, {
    id: syndicateMailId.REMOVED_MEMBER_OWN,
    model: playerSyndicateData,
    onChange: handleSyndicateCbx,
    title: "Medlem l\xE4mnar lag"
  })), React.createElement(CheckboxSyndicateItem, {
    id: syndicateMailId.INACTIVATED_OWN,
    model: playerSyndicateData,
    onChange: handleSyndicateCbx,
    title: "Medlem s\xE4tter sig vilande"
  }))), React.createElement(Marketplace, {
    setShouldShowApiError: setShouldShowApiError
  }))));
};
svs.myProfile.react.pages.notifications.Notifications = Notifications;

 })(window);